import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69861df7921dc90014f5004b/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69861df7921dc90014f5004b/website_project/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69861df7921dc90014f5004b/website_project/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69861df7921dc90014f5004b/website_project/src/components/WhatsAppButton.tsx");
